import FeatureCard from "./FeatureCard";
import LocationIcon from "../images/location.svg";
import DocumentIcon from "../images/document.svg";
import ReviewIcon from "../images/person.svg";
import ShieldIcon from "../images/security.svg";
import { useTranslation } from "react-i18next";
export default function WhatYouGet() {
  const { t } = useTranslation();
  const features = [
    {
      icon: LocationIcon,
      title: "Canton-specific approach",
      desc: "We collect the right details based on where you live.",
    },
    {
      icon: DocumentIcon,
      title: "Clear document checklis",
      desc: "You'll know exactly what to provide—no confusion.",
    },
    {
      icon: ReviewIcon,
      title: "Human review & accuracy checks",
      desc: "Your filing is reviewed by a specialist, not only software.",
    },
    {
      icon: ShieldIcon,
      title: "Secure handling",
      desc: "Your data is used only for your tax filing request.",
    },
  ];
  return (
    <section id="benefits" className="w-full px-4 py-16 bg-white md:px-10">
      <div className="max-w-[1536px] mx-auto flex flex-col gap-10">
        <div className="text-center animate-on-scroll">
          <h2 className="text-2xl font-bold font-poppins text-dark md:text-3xl lg:text-4xl">
            {t(" What you Get with")}
            {/* Warum Tausende Schweizer uns vertrauen */}

          </h2>
          <span
            className="
    mb-5 font-black leading-tight font-poppins
    text-2xl md:text-3xl lg:text-4xl
    bg-[linear-gradient(90deg,#22D3EE_0%,#06B6D4_35%,#0EA5E9_65%,#22C55E_100%)]
    bg-clip-text text-transparent
  
  ">
            {t("Our Tax Filing Service")}
          </span>
        </div>

        <div className="flex flex-wrap gap-5">
          {features.map((f, index) => (
            <FeatureCard
              key={index}
              icon={f.icon}
              title={t(f.title)}
              desc={t(f.desc)}
              animationClass={`animate-on-scroll stagger-${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}